import { ChevronLeftIcon, ChevronRightIcon } from '@root/styles/icons';
import { FC, useState } from 'react';

import { SingleDatePicker } from 'react-dates';
import { useId } from 'react-id-generator';
import { DATE_FORMAT } from '../../constants';
import { DateInputProps } from '../../types';
import { StyledMobileInputWrapper } from './SingleMobileInput.styles';

export const SingleMobileInput: FC<DateInputProps> = ({ onDateChange, startDate }) => {
  const [startDateMobileInputId] = useId();
  const [focused, setFocused] = useState(false);

  return (
    <>
      <StyledMobileInputWrapper>
        <SingleDatePicker
          focused={focused}
          onFocusChange={({ focused }) => setFocused(focused)}
          hideKeyboardShortcutsPanel
          date={startDate}
          id={startDateMobileInputId}
          onDateChange={(date) => {
            if (date && onDateChange) {
              onDateChange(date);
            }
          }}
          displayFormat={DATE_FORMAT}
          navNext={<ChevronRightIcon />}
          navPrev={<ChevronLeftIcon />}
          numberOfMonths={1}
        />
      </StyledMobileInputWrapper>
    </>
  );
};
